import React, {useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next';
import SimpleModal from "./SimpleModal";
import InputText from "../shared/InputText";

const defaultState = {
    password: '',
    confirmPassword: ''
}

function ApiKeyPasswordModal({isOpen, onCancel, onOk, title, children, processing}) {

    const {t} = useTranslation();

    const [error, setError] = useState("");
    const [passwordState, setPasswordState] = useState({
        password: '',
        confirmPassword: ''
    });

    useEffect(() => {
        if(isOpen) {
            setPasswordState(defaultState);
        }
    }, [isOpen])

    function handlePasswordStateChange(name) {
        return function(event) {
            let value;
            if(event.target.value.length < 15) {
                value = event.target.value;
                setPasswordState({...passwordState, [name]:value});
            }
        }
    }

    function passwordSend(e, apiK) {
        e.preventDefault();
        setError("");

        if(passwordState.password.length < 8) {
            setError("TOO_SHORT");
            return;
        } else if(passwordState.password.length > 15){
            setError("TOO_LONG");
            return;
        }

        if(passwordState.password && passwordState.confirmPassword) {
            if(passwordState.password === passwordState.confirmPassword) {
                onOk(passwordState);
            } else {
                setError("PASSWORD_DONT_MATCH");
            }
        } else {
            setError("PLEASE_FILL_THE_INFORMATION_NEEDED");
        }
    }

    return (
        <SimpleModal isOpen={isOpen}>
            <form onSubmit={passwordSend}>
                <h3>
                    {t(title)}
                </h3>
                <div>
                    {children}
                    <InputText
                        type="password"
                        value={passwordState.password}
                        onChange={handlePasswordStateChange('password')}
                        required>
                        {t('PASSWORD')}
                    </InputText>
                    <InputText
                        type="password"
                        value={passwordState.confirmPassword}
                        onChange={handlePasswordStateChange('confirmPassword')}
                        required>
                        {t('CONFIRM_PASSWORD')}
                    </InputText>
                    {
                        error ? <React.Fragment>
                            <br/>
                            <span className='error'>{t(error)}</span>
                        </React.Fragment> : null
                    }
                </div>
                <div className={'modal-action'}>
                    <button className={'btn btn-primary'} type="submit" color="primary">{t('OK')}</button>
                    <button className={'btn'
                    } color="secondary" onClick={onCancel}>{t('CANCEL')}</button>
                </div>
            </form>
        </SimpleModal>
    )
}

export default ApiKeyPasswordModal;
